import { Make } from '@carcodex/frontend-types/modules/car/car.types';
import clsx from 'clsx';
import { DATE_FORMAT } from 'constants/constants';
import moment from 'moment';
import { RootState } from 'pages/_store/root-reducer';
import { FC, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { OfferType, OrderQueryParams, OwnershipType, PublicOffer } from 'types';
import BoaRedirection from './BoaRedirection/BoaRedirection';
import { useStyles } from './EditOrderPage.styles';
import { messages } from './EditOrderPage.translations';
import FormContent from './FormContent/FormContent';
import { Actions as OrderActions } from './store/actions';

interface Props {
  isDocumentsUpload: boolean;
}

const EditOrderPage: FC<Props> = ({ isDocumentsUpload }) => {
  const { formatMessage } = useIntl();
  const classes = useStyles();
  const dispatch = useDispatch();
  const { orderId } = useParams<OrderQueryParams>();

  const order = useSelector<RootState, PublicOffer>((state) => state.orderPage.order, shallowEqual);

  useEffect(() => {
    dispatch(OrderActions.getOrderRequest(orderId));
  }, [orderId, dispatch]);

  useEffect(() => {
    const modelSlug = order?.esDeal?.modelSlug;
    const isTeslaOEM =
      order?.offerType === OfferType.OEM &&
      order?.ownershipType !== OwnershipType.PRIVATE_CREDIT &&
      order?.esDeal?.make === Make.TESLA;

    if (modelSlug && isTeslaOEM && orderId === order?.publicId) {
      dispatch(OrderActions.getTeslaTrimCodesRequest(orderId, modelSlug));
    }
  }, [order?.esDeal?.modelSlug, dispatch, orderId, order?.publicId]);

  useEffect(() => {
    if (order?.offerType === OfferType.OEM && orderId === order?.publicId) {
      dispatch(OrderActions.getOrderFinanceConditionsRequest(orderId));
    }
  }, [orderId, dispatch, order?.offerType, order?.publicId]);

  return (
    <div className={clsx('EditOrderPage', classes.root)}>
      <div className={classes.headerContainer}>
        <div className={classes.header}>{formatMessage(messages.EditOrderPageEditOrder)}</div>
        {!!order?.createdAt && (
          <div className={classes.subHeader}>
            {formatMessage(messages.EditOrderPageCreated, {
              dateString: moment(order?.createdAt).format(DATE_FORMAT),
            })}
          </div>
        )}
      </div>
      <FormContent isDocumentsUpload={isDocumentsUpload} />

      <BoaRedirection orderId={orderId} />
    </div>
  );
};
export default EditOrderPage;
